import { render, staticRenderFns } from "./NavPrimary.vue?vue&type=template&id=05040bf8&"
import script from "./NavPrimary.vue?vue&type=script&lang=js&"
export * from "./NavPrimary.vue?vue&type=script&lang=js&"
import style0 from "./NavPrimary.vue?vue&type=style&index=0&id=05040bf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports